import axios from 'axios';

const addNewStaff = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/staff`, data)
    .then(res => res)
    .catch(err => err);
};

export default addNewStaff;
